exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messages-list[data-v-1d34bcf0]{max-height:60vh;overflow-y:scroll}@media only screen and (max-width:1200px){.messages-list[data-v-1d34bcf0]{max-height:40vh;overflow-y:scroll}}@media only screen and (max-width:900px){.messages-list[data-v-1d34bcf0]{max-height:45vh;overflow-y:scroll}}@media only screen and (max-width:500px){.messages-list[data-v-1d34bcf0]{max-height:40vh;overflow-y:scroll}}@media only screen and (max-width:360px){.messages-list[data-v-1d34bcf0]{max-height:40vh;overflow-y:scroll}}", ""]);

// exports
